import documents from './modules/documents'
import customer from './modules/customer'
import policy from './modules/policy'
import policyModify from './modules/policyModify'
import home from './modules/home'
import product from './modules/product'
import lose from './modules/lose'
import stat from './modules/stat'

export default [
  ...documents,
  ...customer,
  ...policy,
  ...policyModify,
  ...home,
  ...product,
  ...lose,
  ...stat
]
